'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash.curry');

var _lodash2 = _interopRequireDefault(_lodash);

var _constants = require('./helpers/constants');

var _util = require('./helpers/util');

var _isValid = require('./isValid');

var _isValid2 = _interopRequireDefault(_isValid);

var _get = require('./get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tokenFunctions = {
  YYYY: function YYYY(d) {
    return (0, _util.fill)(4, d.getUTCFullYear());
  },
  YY: function YY(d) {
    return (0, _util.lastN)(2, (0, _util.fill)(4, d.getUTCFullYear()));
  },
  MMMM: function MMMM(d) {
    return _constants.MONTHS[d.getUTCMonth()];
  },
  MMM: function MMM(d) {
    return (0, _util.firstN)(3, _constants.MONTHS[d.getUTCMonth()]);
  },
  MM: function MM(d) {
    return (0, _util.fill)(2, d.getUTCMonth() + 1);
  },
  M: function M(d) {
    return d.getUTCMonth() + 1;
  },
  w: function w(d) {
    return (0, _get2.default)('week', d);
  },
  ww: function ww(d) {
    return (0, _util.fill)(2, (0, _get2.default)('week', d));
  },
  DD: function DD(d) {
    return (0, _util.fill)(2, d.getUTCDate());
  },
  D: function D(d) {
    return d.getUTCDate();
  },
  dddd: function dddd(d) {
    return _constants.WEEKDAYS[d.getUTCDay()];
  },
  ddd: function ddd(d) {
    return (0, _util.firstN)(3, _constants.WEEKDAYS[d.getUTCDay()]);
  },
  dd: function dd(d) {
    return (0, _util.firstN)(2, _constants.WEEKDAYS[d.getUTCDay()]);
  },
  d: function d(_d) {
    return _d.getUTCDay();
  },
  HH: function HH(d) {
    return (0, _util.fill)(2, d.getUTCHours());
  },
  H: function H(d) {
    return d.getUTCHours();
  },
  hh: function hh(d) {
    return (0, _util.fill)(2, modCeiling(12, d.getUTCHours()));
  },
  h: function h(d) {
    return modCeiling(12, d.getUTCHours());
  },
  mm: function mm(d) {
    return (0, _util.fill)(2, d.getUTCMinutes());
  },
  m: function m(d) {
    return d.getUTCMinutes();
  },
  ss: function ss(d) {
    return (0, _util.fill)(2, d.getUTCSeconds());
  },
  s: function s(d) {
    return d.getUTCSeconds();
  },
  A: function A(d) {
    return d.getUTCHours() > 11 ? 'PM' : 'AM';
  },
  a: function a(d) {
    return d.getUTCHours() > 11 ? 'pm' : 'am';
  },
  SSS: function SSS(d) {
    return (0, _util.fill)(3, d.getUTCMilliseconds());
  },
  SS: function SS(d) {
    return (0, _util.firstN)(2, (0, _util.fill)(3, d.getUTCMilliseconds()));
  },
  S: function S(d) {
    return (0, _util.firstN)(1, (0, _util.fill)(3, d.getUTCMilliseconds()));
  },
  Q: function Q(d) {
    return Math.ceil((d.getUTCMonth() + 1) / 3);
  }
}; //@flow


var modCeiling = function modCeiling(mod, val) {
  return val % mod || mod;
};

var swapTokenWithValue = (0, _lodash2.default)(function (date, token) {
  return tokenFunctions[token] ? tokenFunctions[token](date) : token;
});

exports.default = (0, _lodash2.default)(function (format, date) {
  if ((0, _isValid2.default)(date) === false) return 'Invalid Date';

  return format.match(_constants.DATE_TOKENS).map(swapTokenWithValue(date)).join('');
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fp/build/format.js
// module id = 1400
// module chunks = 0 1 2 3 4 5 7 8 9